// components/filePreview/renderers/PdfRenderer.tsx
// ✅ Remove react-pdf entirely — use iframe with blob URL
import { Box } from "@mui/material";

export const PdfRenderer = ({ blobUrl }: { blobUrl: string }) => {
  console.log("🔵 PDF blobUrl:", blobUrl); // check — should start with blob:http://

  return (
    <Box sx={{ width: "100%", height: "65vh" }}>
      <iframe
        src={blobUrl}
        width="100%"
        height="100%"
        style={{ border: "none", borderRadius: 8 }}
        title="PDF Preview"
      />
    </Box>
  );
};